export default "/_next/static/videos/980acf2edf89439ebce0df45136ab14e.mp4";